import React, { useEffect, useState } from 'react';
import { RiSearchLine, RiFilter3Line } from 'react-icons/ri';
import { get } from '../../utility/fetch';
import { AiOutlinePlus } from 'react-icons/ai';
import WalkInModal from '../modals/WalkInModal';
import Spinner from '../UI/Spinner';

function CHPMembers() {
    const [searchQuery, setSearchQuery] = useState('');
    const [filter, setFilter] = useState('');
    const [results, setResults] = useState([
    ]);
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [registerData, setRegisterData] = useState({});

    const pageStyles = {
        padding: '24px',
        width: '100%',
        margin: '0 auto',
        backgroundColor: '#f8fafc',
        marginTop: '40px',
        marginBottom: '20px',
    };

    const headerStyle = {
        background: 'linear-gradient(90deg, #1C811C 0%, #2E9E2E 100%)',
        padding: '24px',
        borderRadius: '12px',
        marginBottom: '24px',
        boxShadow: '0 4px 16px rgba(28, 129, 28, 0.15)',
        color: '#ffffff',
    };

    const searchContainerStyle = {
        display: 'flex',
        gap: '16px',
        marginBottom: '24px',
        alignItems: 'center',
    };

    const inputStyle = {
        flex: 1,
        padding: '12px',
        borderRadius: '8px',
        border: '1px solid #e2e8f0',
        fontSize: '14px',
    };

    const buttonStyle = {
        backgroundColor: '#1C811C',
        color: '#ffffff',
        padding: '12px 24px',
        borderRadius: '8px',
        border: 'none',
        cursor: loading ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontWeight: '600',
        opacity: loading ? 0.7 : 1,
    };

    const tableContainerStyle = {
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '20px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '14px',
    };

    const thStyle = {
        textAlign: 'left',
        padding: '12px',
        borderBottom: '2px solid #e2e8f0',
        color: '#1C811C',
        fontWeight: '600',
    };

    const tdStyle = {
        padding: '12px',
        borderBottom: '1px solid #e2e8f0',
    };

    // const getAllPatients = async () => {
    //     setLoading(true);
    //     try {
    //       let res = await get(`/patient/list`);
    //       // let res = await get(`/walkinlabrequest/list`);
    //       console.log(res)
    //       setResults(res?.data);
    //       setTotalPages(Math.ceil((res?.data?.length) / 10));
    //     } catch (error) {
    //       console.error('Error fetching all patients:', error);
    //     } finally {
    //       setLoading(false);
    //     }
    //   };

    const searchPatients = async () => {
        setLoading(true);
        console.log('Searching:', searchQuery, 'Filter:', filter);
        try {
            let url = '/patient/filter-list/';
            if (filter) {
                url += `${filter}/${searchQuery}/`;
            }
            url += `1/100`;
            let res = await get(url);

            console.log(res);

            setResults(res?.data?.recordList);
        } catch (error) {
            console.error('Error fetching patients:', error);
        } finally {
            setLoading(false);
        }
    };

    const register = (data) => {
        setRegisterData(data);
        setOpenModal(true);
    }

    useEffect(() => {
        // getAllPatients();
    })

    const handleSearch = () => {
        // Implement search functionality
        console.log('Searching:', searchQuery, 'Filter:', filter);
    };

    // Sample data for demonstration
    const sampleData = [
        { id: 1, firstName: 'John', lastName: 'Doe', email: 'john@example.com' },
        { id: 2, firstName: 'Jane', lastName: 'Smith', email: 'jane@example.com' },
        // Add more sample data as needed
    ];

    // Add new styles for profile picture
    const profileImageStyle = {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        objectFit: 'cover',
        marginRight: '10px'
    };

    const profileCellStyle = {
        ...tdStyle,
        display: 'flex',
        alignItems: 'center',
    };

    // Function to handle image loading errors
    const handleImageError = (e) => {
        e.target.src = 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y';
        // You can also use a local default image:
        // e.target.src = '/path/to/default-avatar.png';
    };

    // Add loader style
    const loaderContainerStyle = {
        display: 'flex',
        justifyContent: 'center',
        padding: '40px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
    };

    return (
        <div style={pageStyles}>
            <div style={headerStyle}>
                <h1 style={{ margin: 0, fontSize: '24px', fontWeight: '700' }}>
                    Search for Connect Health Pro Members
                </h1>
            </div>

            <div style={searchContainerStyle}>
                <select
                    style={inputStyle}
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    disabled={loading}
                >
                    <option value="">Select Filter</option>
                    <option value="firstName">First Name</option>
                    <option value="lastName">Last Name</option>
                    <option value="email">Email</option>
                    <option value="patientRef">Patient Reference No.</option>
                </select>

                <input
                    type="text"
                    placeholder="Search members..."
                    style={inputStyle}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    disabled={loading}
                />

                <button 
                    style={buttonStyle} 
                    onClick={searchPatients}
                    disabled={loading}
                >
                    {loading ? (
                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            Searching... <Spinner width={20} height={20} />
                        </span>
                    ) : (
                        <>
                            <RiSearchLine size={20} />
                            Search
                        </>
                    )}
                </button>
            </div>

            {loading ? (
                <div style={loaderContainerStyle}>
                    <Spinner width={40} height={40} />
                </div>
            ) : results?.length > 0 ? (
                <div style={tableContainerStyle}>
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={thStyle}>Patient Ref</th>
                                <th style={thStyle}></th>
                                <th style={thStyle}>First Name</th>
                                <th style={thStyle}>Last Name</th>
                                <th style={thStyle}>Email</th>
                                <th style={thStyle}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.map((item, index) => (
                                <tr key={item.id}>
                                    <td style={tdStyle}>{item.patientRef}</td>
                                    <td style={profileCellStyle}>
                                        <img
                                            src={item.pictureUrl || 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y'}
                                            onError={handleImageError}
                                            alt={`${item.firstName}'s profile`}
                                            style={profileImageStyle}
                                        />
                                    </td>
                                    <td style={tdStyle}>{item.firstName}</td>
                                    <td style={tdStyle}>{item.lastName}</td>
                                    <td style={tdStyle}>{item.email}</td>
                                    <td style={tdStyle}>
                                        <button 
                                            onClick={() => register(item)} 
                                            className="rounded-btn m-r-10"
                                        >
                                            <div className="flex flex-v-center">
                                                <span>Place Order</span>
                                                <AiOutlinePlus size={15} className="m-l-10 pointer" />
                                            </div>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                searchQuery && !loading && (
                    <div style={{...tableContainerStyle, textAlign: 'center', padding: '40px'}}>
                        No results found
                    </div>
                )
            )}

            {
                openModal && <WalkInModal patientData={registerData} closeModal={() => setOpenModal(false)}/>
            }
        </div>
    );
}

export default CHPMembers;